import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';
import { useEventListener } from '../scripts/hooks';
var DropdownList = function DropdownList(_ref) {
  var _ref$dropdowns = _ref.dropdowns,
    dropdowns = _ref$dropdowns === void 0 ? [] : _ref$dropdowns,
    _ref$isLegacy = _ref.isLegacy,
    isLegacy = _ref$isLegacy === void 0 ? false : _ref$isLegacy;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activeDropdown = _useState2[0],
    setActiveDropdown = _useState2[1];
  useEffect(function () {
    document.addEventListener('click', onOutsideClick, true);
    return function () {
      document.removeEventListener('click', onOutsideClick, true);
    };
  }, []);
  var onClickHandler = function onClickHandler(e) {
    var listname = e.currentTarget.dataset.listname;
    setActiveDropdown(function (prev) {
      return prev === listname ? '' : listname;
    });
  };
  var onKeydown = function onKeydown(_ref2) {
    var key = _ref2.key;
    if (key === 'Esc' || key === 'Escape') {
      setActiveDropdown('');
    }
  };
  var onOutsideClick = function onOutsideClick(e) {
    var _e$target$className, _e$target$className$i;
    if (!((_e$target$className = e.target.className) !== null && _e$target$className !== void 0 && (_e$target$className$i = _e$target$className.includes) !== null && _e$target$className$i !== void 0 && _e$target$className$i.call(_e$target$className, 'site-footer__feature'))) {
      setActiveDropdown('');
    }
  };
  useEventListener('keydown', onKeydown);
  var dropdownsListItems = dropdowns.map(function (_ref3) {
    var menuItems = _ref3.menuItems,
      text = _ref3.text;
    return /*#__PURE__*/React.createElement(Dropdown, {
      key: text,
      listName: text,
      menuItems: menuItems,
      isLegacy: isLegacy,
      isOpen: text === activeDropdown,
      onClickHandler: onClickHandler
    });
  });
  return /*#__PURE__*/React.createElement("section", {
    className: "site-footer__subfooter"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
    className: "site-footer__subfooter-features"
  }, dropdownsListItems)));
};
export default DropdownList;
DropdownList.propTypes = {
  dropdowns: PropTypes.instanceOf(Array).isRequired,
  isLegacy: PropTypes.bool
};